/*  ========================================================================
    # Hooks - Use Pages API
    ========================================================================  */

import { useEffect, useState } from 'react';

const usePagesApi = params => {
  const [loadingPages, setLoadingPages] = useState(true);
  const [pages, setPages] = useState([]);
  const paramsString = new URLSearchParams();

  const getPosts = async () => {
    for (const [key, value] of Object.entries(params)) {
      paramsString.append(key, value);
    }

    try {
      const response = await fetch(`/wp-json/wp/v2/pages?${paramsString.toString()}`);

      if (response.status !== 200) {
        throw new Error(await response.text());
      }

      const pages = await response.json();
      const mappedPages = pages.map(page => ({
        id: page.id,
        image: page.featured_image,
        title: page.title.rendered,
        date: page.date,
        excerpt: page.excerpt.rendered.replace('<p>', '').replace('</p>', ''),
        url: page.link
      }));

      setLoadingPages(false);
      setPages(mappedPages);
    } catch (error) {
      setLoadingPages(false);
      console.log(error); // eslint-disable-line
    }
  };

  useEffect(() => {
    getPosts();
  }, [params.per_page, params.search]);

  return { loadingPages, pages };
};

export default usePagesApi;
